import selector from "frontend/dom/selector"
import first from "rfuncs/functions/first"

export default (element, behaviour) => {
  const el = first(selector(element || window.location.hash || "body"))
  return el ? el.scrollIntoView(behaviour) : null
}
